import request from '@/util/request';
import qs from 'qs';

export const fieldDetail = (params, options) =>
request.get('/api/v4ward/setting/field/basic/detail', Object.assign({}, options, { params }));



export const saveFieldDetail = (params, options) =>
request.post('/api/v4ward/setting/field/custom/save', params,options)